<template>
    <b-card
        :border-variant="borderColor"
        :header="header"
        :no-body="noBody"
        :title="title"
        @click="$emit('click')"
    >
        <slot />
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
    components: { BCard },
    props: {
        borderColor: { type: String },
        header: { type: String },
        noBody: { type: Boolean },
        title: { type: String },
    }
}
</script>